import * as React from "react";

export const MoviesDashboard = () => {
    return <div className="movies">
        Not yet implemented
    </div>
}

